<app-wild-header [hidebusinesslinks]="true"></app-wild-header>
<div class="max-w-2xl mx-auto pt-16 pb-24 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
  <app-sharedbasket></app-sharedbasket>
</div>
<app-footer></app-footer>